/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-time-alarm': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 17.5a6.875 6.875 0 110-13.75 6.875 6.875 0 010 13.75zM10 5a5.625 5.625 0 100 11.25A5.625 5.625 0 0010 5zm1.619 8.125l-2.244-2.244V6.875h1.25v3.488l1.875 1.88-.881.882zM2.5 4.745l2.239-2.243.885.883-2.239 2.243-.885-.883zM14.375 3.38l.884-.883 2.238 2.243-.884.883-2.238-2.243z"/>'
  }
})
